export default class Layer {

  constructor(canvas) {

    this.fixed = false;
    this.canvas = canvas;
    this.ctx = this.canvas.getContext('2d');

    this.ctx.imageSmoothingEnabled = false;

    this.elements = [];

    this.width = 10;
    this.height = 10;

    this.x = 0;
    this.y = 0;

    this.scale = 2;

    this.hasZIndices = false;
    this.needsSort = false;

    this.needsPositioning = false;

    this.hidden = false;
    this.fullRedraw = false;

    this.friend = null;
    this.needsFullRedraw = false;

  }


  show() {
    this.hidden = false;
  }

  hide() {
    this.hidden = true;
  }

  setScale(scale, width, height) {

    this.scale = scale;

    this.elements.forEach(element => {
      element.setScale(scale);
    });


    this.resize(width, height);


  }

  push(element) {

    element.setScale(this.scale);
    this.elements.push(element);

  }

  resize(width, height) {

    this.canvas.width = width * this.scale;
    this.canvas.height = height * this.scale;

    this.width = width * this.scale;
    this.height = height * this.scale;

    this.forceRedraw();

  }

  forceRedraw() {

    this.needsFullRedraw = true;

    let i = this.elements.length;
    while (i--) {
      this.elements[i].needsRendering = true;
      this.elements[i].needsPositioning = true;
    }

  }

  forceReposition() {
    this.needsPositioning = true;
  }

  clear() {

    this.ctx.width = this.ctx.width  * 1;
    this.ctx.canvas.width = this.ctx.canvas.width * 1;


  }

  render(gameX, gameY, gameWidth, gameHeight, allowRender) {

    let i;

    if (this.fullRedraw || this.needsFullRedraw) {
      this.clear();
    }
    else{

      i = this.elements.length;
      while (i--) {

        let element = this.elements[i];
        element.clear(this.ctx, gameX, gameY, gameWidth, gameHeight);

      }

    }

    let renderedPositions = [];

    i = this.elements.length;
    while (i--) {

      let element = this.elements[i];

      if (this.needsFullRedraw || (allowRender !== false && element.needsRendering)) {
        element.render(this.ctx);
      }

      let name = element.constructor.name + '_' + Math.floor(element.x) + '_' + Math.floor(element.y);

      if (!renderedPositions.includes(name) && !element.hidden) {


        element.position(this.ctx, gameX, gameY, gameWidth, gameHeight, this.fullRedraw);

        renderedPositions.push(name);

      }


    }
    this.needsFullRedraw = false;

  }

  mouseMove(x, y) {


    let status = null;
    this.elements.forEach(element => {

      if (status){
        return;
      }

      if (x > element.x && x < element.x + element.width) {

        if (y > element.y && y < element.y + element.height) {
          status = element.hover(x - element.x, y - element.y);
        }

      }

    });

    return status;

  }

  mouseClick(x, y) {

    let status = false;
    this.elements.forEach(element => {

      if (status){
        return;
      }

      // if (element.constructor.name !== 'Room') {
      //   return;
      // }

      if (x > element.x && x < element.x + element.width) {

        if (y > element.y && y < element.y + element.height) {
          status = element.click(x - element.x, y - element.y);
        }

      }

    });

    return status;

  }

  garbageCollect() {

    this.canvas.width = 1;
    this.canvas.height = 1;
    this.ctx.width = 1;
    this.ctx.height = 1;

    let i = this.elements.length;
    while (i--) {
      this.elements[i].garbageCollect();
    }

    // clear out elements, freeing up memory
    this.elements.splice();

  }

}
